export const PRIMEUR_LOGIN_STATUS = {
  NO_LOGIN: 'noLogin',
  LOGGED_IN: 'loggedIn',
};
